import clsx from "clsx";

import NavItem from "features/layout/components/NavItem";

import OnboardingProgressCircle from "common/components/OnboardingProgressCircle";
import useOnboardingProgress from "common/hooks/useOnboardingProgress";

import type { JSX, ReactNode } from "react";

export default function OnboardingNavItem({
  children,
  icon,
  isExpanded,
  isActive,
}: {
  children: ReactNode;
  icon: JSX.Element;
  isExpanded: boolean;
  isActive: boolean;
}) {
  const { completedStepsCount, isLoadingProgress } = useOnboardingProgress();

  const circleComponentProps = {
    isLoading: isLoadingProgress,
    value: completedStepsCount,
    size: "sm",
  } as const;

  const circleComponent = (
    <OnboardingProgressCircle
      {...circleComponentProps}
      className={clsx(
        "absolute left-1.25 top-1.25 transition-opacity",
        isExpanded ? "opacity-0" : "opacity-100",
      )}
    />
  );

  return (
    <NavItem
      icon={
        <>
          {icon}
          {circleComponent}
        </>
      }
      isActive={isActive}
      isExpanded={isExpanded}
    >
      {children}
      <OnboardingProgressCircle {...circleComponentProps} className="ml-auto" />
    </NavItem>
  );
}
